module.exports = __webpack_public_path__ + "media/assets/images/blog/no_managers-f63739a7110fc86be201903429f29bbe.png";